import core from '../modules/core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  resource(parameters={}) {
    return core.call({
      url: '/api/v1/resource/sample',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    });  
  },
  list(parameters={}) {
    return core.call({
      url: '/api/v1/resource/list',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    });  
  },
  complex(parameters={}) {
    return core.call({
      url: '/api/v1/resource/complex',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }    
    });  
  }
}
